module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-2.78b5b7ab.webp";